import { observable } from 'mobx';
import Model from './Model';


class User extends Model {
  static basePath = '/api/users';
  static verboseName = 'User';

  @observable id;
  @observable username;
  @observable password;
  @observable first_name;
  @observable last_name;
  @observable email;
  @observable groups;
  @observable permissions = [];
  @observable is_staff;
  @observable is_active;
  @observable is_superuser;

  static userPath(id) {
     return `/users/${id}/`;
  }

  toString() {
    if (this.first_name && this.last_name) {
      return `${this.first_name} ${this.last_name}`;
    } else if (this.username) {
      return this.username;
    }
    return super.toString();
  };

  can(permission) {
    return this.permissions.indexOf(permission) !== -1;
  }

}


export default User;
